import React from 'react';
import './NewAdvancements.css';

function NewAdvancements({ onClose, news }) {
  return (
    <div className='dialogbackground' onClick={onClose}>
      <div className='newadvancementsdialog'>
        <div className='newadvancementsheader'>New advancements unlocked!</div>
        {
          news.map(advancement =>
            <div key={advancement.id} className='newadvancement'>
              <div className='newadvancementcause'>
                {
                  advancement.requiredAdvancements.map((requirement, i) =>
                    <React.Fragment key={i}>
                      { i !== 0 && <div className='newadvancementsymbol'><div className='text'>+</div><div className='spacer'>&nbsp;</div></div> }
                      <div className='newadvancementrequirement'>
                        <img alt="" src={require(`./images/${requirement.id}.svg`).default}></img>
                        {requirement.name}  
                      </div>
                    </React.Fragment>
                  )
                }
              </div>
              <div className='newadvancementdivider'>&#8658;</div>
              <div className='newadvancementeffect'>
                {
                  advancement.ancestorAdvancement ? 
                    <div className='newadvancementancestor'>
                      <img alt="" src={require(`./images/${advancement.ancestorAdvancement.id}.svg`).default}></img>
                      {advancement.ancestorAdvancement.name}
                    </div>
                    :
                    <div className='newadvancementland'>
                      <img alt="" src={require(`./images/land.svg`).default}></img>
                      {advancement.land}
                    </div>
                }
                <div className='newadvancementsymbol'><div className='text'>&#8594;</div><div className='spacer'>&nbsp;</div></div>
                <div className='newadvancementresult'>
                  <img alt="" src={require(`./images/${advancement.id}.svg`).default}></img>
                  {advancement.name}
                </div>
              </div>
            </div>
          )
        }
        <div className='logreminder'>Find these again in the log book <img alt="Log" title="Log" src={require(`./images/log.svg`).default} /></div>
      </div>
    </div>
  );
}

export default NewAdvancements;
